import {useMuseumFilterState} from "@ekultur/museum-filter";
import {useMyMuseumsState} from './myMuseumsContext'
import {isEqual} from "lodash";

export const useHasFilterModifications = () => {
    const {checked} = useMuseumFilterState();
    const {museumIdsFilter} = useMyMuseumsState();

    return !isEqual(museumIdsFilter.sort(), checked.sort());
}